import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";
import SHOP from "@/config/shop";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    axios.get(`${API}/settings`).then(res => setSettings(res.data)).catch(() => {});
  }, []);

  const phone = settings?.contact_phone || SHOP.contact.defaultPhone;
  const email = settings?.contact_email || SHOP.contact.defaultEmail;
  const companyName = settings?.company_name || SHOP.company.name;
  const companyIco = settings?.company_ico || '24299898';
  const companyAddress = settings?.company_address || 'U Továren 999/31';
  const companyZip = settings?.company_zip || '102 00';
  const companyCity = settings?.company_city || 'Praha 10';

  return (
    <footer className="bg-slate-800 text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-8 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="font-bold text-xl mb-4" data-testid="footer-brand">{SHOP.name}</div>
            <p className="text-slate-400 text-sm">{SHOP.footerText}</p>
            <p className="text-slate-500 text-xs mt-4" data-testid="footer-company-name">{companyName}</p>
            <p className="text-slate-500 text-xs" data-testid="footer-company-ico">ICO: {companyIco}</p>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">Kategorie</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/produkty" className="hover:text-white transition-colors">Vse produkty</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">Informace</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/o-nas" className="hover:text-white transition-colors">O nas</Link></li>
              <li><Link to="/dokumenty" className="hover:text-white transition-colors">Dokumenty</Link></li>
              <li><Link to="/doprava" className="hover:text-white transition-colors">Doprava a platba</Link></li>
              <li><Link to="/obchodni-podminky" className="hover:text-white transition-colors">Obchodni podminky</Link></li>
              <li><Link to="/jak-nakupovat" className="hover:text-white transition-colors">Jak nakupovat</Link></li>
              <li><Link to="/sledovani-objednavky" className="hover:text-white transition-colors">Sledovani objednavky</Link></li>
              <li><Link to="/kontakty" className="hover:text-white transition-colors">Kontakty</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider">Kontakt</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li className="flex items-center gap-2" data-testid="footer-phone"><Phone className="w-4 h-4" /> {phone}</li>
              <li className="flex items-center gap-2" data-testid="footer-email"><Mail className="w-4 h-4" /> {email}</li>
              <li className="flex items-start gap-2" data-testid="footer-address"><MapPin className="w-4 h-4 mt-0.5" /> {companyAddress}<br/>{companyZip} {companyCity}</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-slate-700 mt-8 pt-8 text-center text-sm text-slate-500">
          &copy; {new Date().getFullYear()} {SHOP.domain} – {companyName}. Vsechna prava vyhrazena.
        </div>
      </div>
    </footer>
  );
}
